/**
 * isNode
 * @author donaldcen
 * @createTime 2017/9/19
 */

export default function () {
  return typeof process === 'object' && Object.prototype.toString.call(process) === '[object process]'
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isNode.js